import React, { useEffect, useState } from "react";
import PiplelineDashboardFilterModel from "../../app/models/PiplelineDashboardFilterModel";
import { OMSDropdown } from "../../app/common/common-components/OMSDropdown";
import { OMSMultiselectPTDropdown } from "../../app/common/common-components/OMSMultiselectTagDropdown";
import { OMSMultiselectDropdown } from "../../app/common/common-components/OMSMultiselectDropdown";
import { OMSTwitterAutocomplete2 } from "../../app/common/common-components/OMSAutocomplete";
import {
  FromDateStringToJavascriptDate,
  FromJavascriptDateToDateString,
  isEntegralSuperUser,
} from "../../app/common/common-functions/functions";
import DatePicker from "react-datepicker";
import { useStore } from "../../app/stores/store";
import { Checkbox } from "@/app/common/common-components/ui/Checkbox";

const LoopFilterComponent = ({
  PipelinesDD,
  PropertyTypesDD,
  AgentsDD,
  Data,
  isAccessPipelinesMenu,
  loopFilterChanged,
  PipelineStagesDD,
  InternalDealTagsDD,
}) => {
  const [WorkspaceAgentId, setWorkspaceAgentId] = useState("");
  const [WorkspaceAgentName, setWorkspaceAgentName] = useState("");
  const [WorkspacePipelineId, setWorkspacePipelineId] = useState("");
  const [WorkspacePipeline, setWorkspacePipeline] = useState("");
  const [AgentId, setAgentId] = useState("");
  const [AgentName, setAgentName] = useState("");
  const [PipelineId, setPipelineId] = useState("");
  const [Pipeline, setPipeline] = useState("");
  const [StageId, setStageId] = useState("");
  const [Stage, setStage] = useState("");
  const [RegistrationEndTo, setRegistrationEndTo] = useState("");
  const [RegistrationEndToDT, setRegistrationEndToDT] = useState(null);
  const [RegistrationStartFrom, setRegistrationStartFrom] = useState("");
  const [RegistrationStartFromDT, setRegistrationStartFromDT] = useState(null);
  const [Areas, setAreas] = useState([]);
  const [PropertyTypes, setPropertyTypes] = useState([]);
  const [StagesDD, setStagesDD] = useState([]);
  const [InternalDealTagsList, setInternalDealTagsList] = useState([]);
  const [InternalDealTags, setInternalDealTags] = useState([]);
  const [DateType, setDateType] = useState(0);
  const [View, setView] = useState(1);
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  useEffect(() => {
    if (Data !== undefined && Data != null) {
      console.log(Data);
      setWorkspaceAgentId(Data.WorkspaceAgentId);
      setWorkspaceAgentName(Data.WorkspaceAgentName);
      setWorkspacePipelineId(Data.WorkspacePipelineId);
      setWorkspacePipeline(Data.WorkspacePipeline);
      setAgentId(Data.AgentId);
      setAgentName(Data.AgentName);
      setPipelineId(Data.PipelineId);
      setPipeline(Data.Pipeline);
      setRegistrationEndTo(Data.RegistrationEndTo);
      setRegistrationStartFrom(Data.RegistrationStartFrom);
      setAreas([...Data.Areas]);
      setPropertyTypes([...Data.PropertyTypes]);
      setRegistrationEndToDT(
        FromDateStringToJavascriptDate(Data.RegistrationEndTo)
      );
      setRegistrationStartFromDT(
        FromDateStringToJavascriptDate(Data.RegistrationStartFrom)
      );
      setStageId(Data.StageId);
      setStage(Data.Stage);
      setInternalDealTags([...Data.InternalDealTags]);
      setInternalDealTagsList(getDefaultInternalDealTags(InternalDealTagsDD));
      setDateType(Data.DateType);
      setView(Data.View);
    }
  }, [Data]);

  const getDefaultInternalDealTags = (tags) => {
    var items = [];
    for (const tagItem of tags) {
      var item = {
        value: tagItem,
        text: tagItem,
      };
      items.push(item);
    }
    return items;
  };

  useEffect(() => {
    let mStageDD = [];
    const milestoneOption = {
      StageDescription: "",
      StageID: "",
      StageName: "Milestone",
      StageOrder: 0,
    };

    if (PipelineId && PipelineStagesDD) {
      //console.log("PipelineStagesDD Data ", PipelineStagesDD, " Data.PipelineId ", Data.PipelineId);

      const selectedPipeline = PipelineStagesDD.find(
        (pipeline) => pipeline.PipelineID == PipelineId
      );

      if (selectedPipeline) {
        mStageDD = selectedPipeline.Stages ? [...selectedPipeline.Stages] : [];

        if (!mStageDD.some((stage) => stage.StageName === "Milestone")) {
          mStageDD.unshift(milestoneOption);
        }
      } else {
        mStageDD = [];
        mStageDD.unshift(milestoneOption);
        setStageId("");
        setStage("");
      }
      setStagesDD(mStageDD);
    } else {
      mStageDD = [];
      mStageDD.unshift(milestoneOption);
      setStageId("");
      setStage("");
      setStagesDD(mStageDD);
    }
  }, [PipelineId]);

  const areaSelectionRemoved = (e) => {
    var index = Areas.indexOf(e);
    if (index > -1) {
      Areas.splice(index, 1);
      setAreas([...Areas]);
    }
  };

  const areaSelectionChanged = (e) => {
    var selectedArea = e.suburb == "" ? e.town : e.town + ", " + e.suburb;
    if (Areas.indexOf(selectedArea) === -1) {
      Areas.push(selectedArea);
      setAreas([...Areas]);
    }
  };

  const handleApplyFilterClick = () => {
    console.log(Stage);
    console.log(StageId);
    const filterModel = new PiplelineDashboardFilterModel();
    filterModel.setData(
      WorkspaceAgentId,
      WorkspaceAgentName,
      WorkspacePipelineId,
      WorkspacePipeline,
      AgentId,
      AgentName,
      PipelineId,
      Pipeline,
      RegistrationStartFrom,
      RegistrationEndTo,
      Areas,
      PropertyTypes,
      true,
      StageId,
      Stage,
      InternalDealTags,
      DateType,
      View
    );
    loopFilterChanged(filterModel);
    window.$("#pipelineFilterModel").modal("hide");
  };

  const handleResetFilterClick = () => {
    const filterModel = new PiplelineDashboardFilterModel();
    filterModel.setData(
      WorkspaceAgentId,
      WorkspaceAgentName,
      WorkspacePipelineId,
      WorkspacePipeline,
      "",
      "",
      "",
      "",
      "",
      "",
      [],
      [],
      true,
      "",
      "",
      [],
      0
    );
    loopFilterChanged(filterModel);
    window.$("#pipelineFilterModel").modal("hide");
  };

  const handlePipelineChange = (e) => {
    setPipelineId(e.newValue);
    setPipeline(e.newText);
  };
  const handlePipelineStageChange = (e) => {
    setStageId(e.newValue);
    setStage(e.newText);
  };

  return (
    <div
      className="modal fade"
      id="pipelineFilterModel"
      tabIndex={-1}
      aria-labelledby="pipelineFilterModel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
            <h4 className="modal-title" id="pipelineFilterModel">
              Filter
            </h4>
          </div>
          <div className="modal-body">
            <fieldset className="mb-4">
              <legend className="h6">Property Types & Deal Tags</legend>
              <div className="row">
                <div className="col-md-4 col-sm-12 mb-3">
                  <OMSMultiselectPTDropdown
                    id="mPropertyTypes"
                    selected={PropertyTypes}
                    data={PropertyTypesDD}
                    onChange={setPropertyTypes}
                    labelField="Property Type(s)"
                  />
                </div>
                <div className="col-md-4 col-sm-12 mb-3">
                  <OMSMultiselectDropdown
                    id="mInternalDealTags"
                    name="InternalDealTagsDD"
                    value={InternalDealTags}
                    options={InternalDealTagsList}
                    valueField="value"
                    labelField="text"
                    onChange={setInternalDealTags}
                    label="Deal Tags"
                  />
                </div>
              </div>
            </fieldset>
            {!isAccessPipelinesMenu && (
              <fieldset className="mb-4">
                <legend className="h6">Agent & Pipeline</legend>
                <div className="row">
                  <div className="col-md-4 col-sm-6 mb-3">
                    <OMSDropdown
                      id="mAgent"
                      name="mAgent"
                      options={AgentsDD}
                      valueField="Value"
                      labelField="Text"
                      value={AgentId}
                      onChange={(e) => {
                        setAgentId(e.newValue);
                        setAgentName(e.newText);
                      }}
                    />
                  </div>
                  <div className="col-md-4 col-sm-6 mb-3">
                    <OMSDropdown
                      id="mPipeline"
                      name="mPipeline"
                      options={PipelinesDD}
                      valueField="Value"
                      labelField="Text"
                      value={PipelineId}
                      onChange={handlePipelineChange}
                    />
                  </div>
                  <div className="col-md-4 col-sm-12 mb-3">
                    <OMSDropdown
                      id="mPipelineStage"
                      name="mPipelineStage"
                      options={StagesDD}
                      valueField="StageID"
                      labelField="StageName"
                      value={StageId}
                      onChange={handlePipelineStageChange}
                    />
                  </div>
                </div>
              </fieldset>
            )}
            <fieldset className="mb-4">
              <legend className="h6">Milestone Date Range</legend>
              <div className="row align-items-center">
                <div className="col-md-12 col-sm-12 col-xs-12 mt-10 mb-10">
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "1rem" }}
                  >
                    <div className="d-flex align-items-center">
                      <Checkbox
                        id="Expected"
                        checked={DateType === 0}
                        onCheckedChange={() => setDateType(0)}
                      />
                      <label
                        htmlFor="Expected"
                        className="mb-0 cursor-pointer"
                        style={{ marginLeft: "8px", marginBottom: "0px" }}
                      >
                        Expected milestone
                      </label>
                    </div>
                    <div className="d-flex align-items-center">
                      <Checkbox
                        id="Completed"
                        checked={DateType === 1}
                        onCheckedChange={() => setDateType(1)}
                      />
                      <label
                        htmlFor="Completed"
                        className="mb-0 cursor-pointer"
                        style={{ marginLeft: "8px", marginBottom: "0px" }}
                      >
                        Completed milestone
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 mb-3">
                  <DatePicker
                    selected={RegistrationStartFromDT}
                    onChange={(date) => {
                      setRegistrationStartFrom(
                        FromJavascriptDateToDateString(date)
                      );
                      setRegistrationStartFromDT(date);
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="From date"
                    className="form-control"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <div className="col-md-4 col-sm-6 mb-3">
                  <DatePicker
                    selected={RegistrationEndToDT}
                    onChange={(date) => {
                      setRegistrationEndTo(
                        FromJavascriptDateToDateString(date)
                      );
                      setRegistrationEndToDT(date);
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="To date"
                    className="form-control"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset className="mb-4">
              <legend className="h6">Location</legend>
              <div className="row align-items-center">
                <div className="col-md-12 mb-2">
                  <label htmlFor="SelectedAreas">Area(s)</label>
                  <OMSTwitterAutocomplete2
                    id="SelectedAreas"
                    name="SelectedAreas"
                    onSelect={areaSelectionChanged}
                  />
                </div>
                {Areas.length > 0 && (
                  <div className="col-md-12">
                    <div className="search-bar__container">
                      <div className="search-bar__autocomplete-input">
                        {Areas.map((e, index) => (
                          <div
                            key={index}
                            className="search-bar__autocomplete-selected"
                          >
                            {e}{" "}
                            <i
                              onClick={() => areaSelectionRemoved(e)}
                              style={{
                                fontSize: 16,
                                cursor: "pointer",
                                marginLeft: "8px",
                              }}
                              className="fa fa-trash"
                            ></i>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </fieldset>
          </div>
          <div className="modal-footer">
            <a
              href="#"
              style={{ marginRight: 5 }}
              onClick={handleResetFilterClick}
            >
              Reset
            </a>
            <button
              type="button"
              className="btn btn-success-oms"
              onClick={handleApplyFilterClick}
            >
              Apply
            </button>
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoopFilterComponent;
